module.exports = __webpack_public_path__ + "img/4.125b0197.png";